import { greekLOT } from './greek_lib'

function replaceChars(str: string, map: any[]) {
    map.forEach((_, regexItem) => {
        str = str.replace(map[regexItem].match, map[regexItem].replace);
    });
    return str;
}

export const EnglishToGreek = (text: string) => replaceChars(text, greekLOT);

// Greek prefix characters that start multi-character sequences
// These should be "silent" until the sequence is completed
export const GREEK_PREFIXES = [';', "'", ':', 'j', 'J', '[', '{', '/'];

// Second-level prefixes (can follow a first-level prefix)
// e.g., ':/' in ':/h' → ῇ
export const GREEK_SECOND_PREFIXES = ['/'];
